import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWpbModel } from "../wpbModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IWpbDetail } from "../wpbTypes";
import moment from 'moment';
import { formatNum } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useWpbModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IWpbDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '采购合同号',
            width: 160,
            dataIndex: 'purchaseCode',
            fixed: "left",
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
            ellipsis: true,
        },
        {
            title: '预警状态',
            width: 150,
            dataIndex: 'warningType',
            render: text => getTreeNodeName(text)
        }, {
            title: '币种',
            width: 100,
            dataIndex: 'currencyName',
            render: text => text ?? "CNY"
        }, {
            title: '应付金额',
            width: 160,
            dataIndex: 'amountTotal',
            render: t => formatNum(t)
        }, {
            title: '已付金额',
            width: 160,
            dataIndex: 'countPrice',
            render: t => formatNum(t)
        }, {
            title: '未付金额',
            width: 160,
            dataIndex: 'waitAmount',
            render: t => formatNum(t),
            sorter: (a, b) =>b.waitAmount - a.waitAmount,
            
        }, {
            title: '付款日期',
            width: 200,
            dataIndex: "settlementTime",
            render: t => moment(t).format("YYYY-MM-DD")
        }, {
            title: '预计付款日期',
            width: 160,
            dataIndex: "estimatedTime",
            render: t => t ? moment(t).format('YYYY-MM-DD') : ''
        }, {
            title: '逾期天数',
            width: 80,
            dataIndex: 'dataNum',
        },
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
